import React, { useState, useEffect, useMemo } from 'react';
import {
	Button,
	Col,
	Input,
	Row,
	Label,
	ModalBody,
	Form,
	TabPane,
	TabContent,
	Spinner,
	FormFeedback,
	FormGroup,
	Nav,
	NavItem,
	NavLink,
} from 'reactstrap';

import classnames from 'classnames';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import { setRequireCloseModal } from '../../../../slices/field/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import OSelect from '../../../../Components/OElements/OSelect';
import { addNewField, updateField } from '../../../../slices/thunks';
import {
	getFieldTypeList,
	getUserCollections,
} from '../../../../helpers/screen/backend_helper';

const FieldForm = ({
	dataField,
	isEdit,
	handleToggleModal,
	isOpen,
	resultHandler,
}) => {
	const dispatch = useDispatch();
	const [activeTab, setActiveTab] = useState('1');

	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	const selectorField = createSelector(
		state => state.Field,
		field => ({
			isAdding: field.isAdding,
			isAdded: field.isAdded,
			isUpdating: field.isUpdating,
			isUpdated: field.isUpdated,
			isLoadingList: field.isLoadingList,
			requireCloseModal: field.requireCloseModal,
		})
	);
	const {
		isAdding,
		isAdded,
		isUpdating,
		isUpdated,
		isLoadingList,
		requireCloseModal,
	} = useSelector(selectorField);

	// validation
	const validation = useFormik({
		initialValues: {
			name: (dataField && dataField.name) || '',
			description: (dataField && dataField.description) || '',
			field_type_id: (dataField && dataField.field_type_id) || '',
			collectionRef: dataField && dataField.collectionRef,
		},
		validationSchema: Yup.object({
			name: Yup.string().required('Campo requerido'),
			description: Yup.string().required('Campo requerido'),
			field_type_id: Yup.string().required('Campo requerido'),
			collectionRef: Yup.string(),
		}),
		onSubmit: values => {
			const field = {
				name: values.name,
				description: values.description,
				field_type_id: values.field_type_id,
				collectionRef: values.collectionRef,
			};

			if (isEdit) {
				field._id = dataField._id;
				dispatch(updateField(field))
					.unwrap()
					.then(result => {
						if (result && resultHandler) {
							resultHandler(result);
						}
					})
					.catch(err => {
						console.error(err);
					});
			} else {
				dispatch(addNewField(field))
					.unwrap()
					.then(result => {
						console.log(result);
						if (result && resultHandler) {
							resultHandler(result);
						}
					})
					.catch(err => {
						console.error(err);
					});
			}
		},
	});

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [requireCloseModal]);

	return (
		<>
			<div className='modal-content border-0 mt-3'>
				<Nav className='nav-tabs nav-tabs-custom nav-success p-2 pb-0 bg-light'>
					<NavItem>
						<NavLink
							href='#'
							className={classnames({ active: activeTab === '1' })}
							onClick={() => {
								toggleTab('1');
							}}
						>
							Información General
						</NavLink>
						{/* <NavLink
							href='#'
							className={classnames({ active: activeTab === '2' })}
							onClick={() => {
								toggleTab('2');
							}}
						>
							Campos
						</NavLink>
						<NavLink
							href='#'
							className={classnames({ active: activeTab === '3' })}
							onClick={() => {
								toggleTab('3');
							}}
						>
							Disposición
						</NavLink> */}
					</NavItem>
				</Nav>
			</div>
			<Form
				className='tablelist-form'
				onSubmit={e => {
					e.preventDefault();

					validation.handleSubmit();
					return false;
				}}
			>
				<ModalBody className='modal-body'>
					<TabContent activeTab={activeTab}>
						<TabPane tabId='1'>
							<Row className='g-3'>
								<Col lg={8}>
									<Label for='name' className='form-label'>
										Nombre
									</Label>
									<Input
										name='name'
										id='name'
										className='form-control'
										placeholder='Ingrese un nombre'
										type='text'
										validate={{ required: { value: true } }}
										onChange={validation.handleChange}
										onBlur={validation.handleBlur}
										value={validation.values.name || ''}
										invalid={
											validation.touched.name &&
											validation.errors.name
												? true
												: false
										}
									/>
									{validation.touched.name &&
									validation.errors.name ? (
										<FormFeedback type='invalid'>
											{validation.errors.name}
										</FormFeedback>
									) : null}
								</Col>
								<Col lg={4}>
									<Label for='description' className='form-label'>
										Descripción
									</Label>
									<Input
										name='description'
										id='description'
										className='form-control'
										placeholder='Ingrese una descripción'
										type='text'
										validate={{ required: { value: true } }}
										onChange={validation.handleChange}
										onBlur={validation.handleBlur}
										value={validation.values.description || ''}
										invalid={
											validation.touched.description &&
											validation.errors.description
												? true
												: false
										}
									/>
									{validation.touched.description &&
									validation.errors.description ? (
										<FormFeedback type='invalid'>
											{validation.errors.description}
										</FormFeedback>
									) : null}
								</Col>
								<Col lg={4}>
									<OSelect
										key='field_type_id'
										label='Tipo de Campo'
										id='field_type_id'
										name='field_type_id'
										value={dataField?.field_type_id || ''}
										requestApi={() => getFieldTypeList()}
										validation={validation}
									/>
								</Col>
								{validation.values.field_type_id ===
									'6671afba9b1f0cc6b4f803dd' && (
									<Col lg={4}>
										<OSelect
											key='collectionRef'
											label='Maestro de datos'
											name='collectionRef'
											value={dataField?.collectionRef || ''}
											requestApi={() => getUserCollections()}
											validation={validation}
										/>
									</Col>
								)}
							</Row>
						</TabPane>
						{/* <TabPane tabId='2'>
							{validation.values.fields.map((row, indexRow) =>
								row.map((campo, indexCampo) => (
									<Row
										className='g-3'
										key={`${indexRow}-${indexCampo}`}
									>
										<Col lg={8}>
											<Label for='field_id' className='form-label'>
												Campo
											</Label>
											<Select
												name='field_id'
												placeholder='Seleccione un campo'
												value={
													validation.values.fields[indexRow][
														indexCampo
													].field_id
												}
												onChange={value => {
													const campos = [
														...validation.values.fields,
													];
													campos[indexRow][indexCampo].field_id =
														value;
													validation.setFieldValue(
														'fields',
														campos
													);
												}}
												data={fieldsList.map(field => ({
													label: `${field.name} - ${field.field_type.name}`,
													value: field._id,
												}))}
											/>
										</Col>
										<Col lg={2}>
											<div className='d-flex'>
												<div>
													<FormGroup className='d-flex gap-2 align-items-center'>
														<Label className=''>
															<div className='d-flex'>
																<Input
																	type='checkbox'
																	checked={
																		validation.values.fields[
																			indexRow
																		][indexCampo].optional
																	}
																	onChange={e => {
																		const campos = [
																			...validation.values
																				.fields,
																		];
																		campos[indexRow][
																			indexCampo
																		].optional =
																			e.target.checked;
																		validation.setFieldValue(
																			'fields',
																			campos
																		);
																	}}
																/>
																<div className='px-1'>
																	Opcional
																</div>
															</div>
														</Label>
														{validation.touched.optional &&
														validation.errors.optional ? (
															<FormFeedback type='invalid'>
																{validation.errors.optional}
															</FormFeedback>
														) : null}
													</FormGroup>
												</div>
											</div>
										</Col>
										<Col lg={2}>
											<Button
												onClick={() => {
													const campos = [
														...validation.values.fields,
													];
													campos[indexRow].splice(indexCampo, 1);
													validation.setFieldValue(
														'fields',
														campos
													);
												}}
												className='btn btn-danger'
											>
												Eliminar
											</Button>
										</Col>
									</Row>
								))
							)}
							<Button
								onClick={() => {
									const campos = [...validation.values.fields];
									campos[campos.length - 1].push({
										field_id: '',
										optional: false,
										size: 4,
									});

									validation.setFieldValue('fields', campos);
								}}
								className='btn btn-primary'
							>
								Agregar
							</Button>
						</TabPane>
						<TabPane tabId='3'>hola</TabPane> */}
					</TabContent>
				</ModalBody>
				<div className='modal-footer'>
					<div className='hstack gap-2 justify-content-end'>
						<Button
							type='button'
							onClick={() => {
								handleToggleModal();
							}}
							className='btn-danger btn-label'
						>
							<i className='icon-x label-icon'></i>
							Cancelar
						</Button>
						<button
							type='submit'
							className='btn btn-label btn-primary'
							id='add-btn'
							disabled={isAdding || isUpdating}
						>
							{isAdding || isUpdating ? (
								<i className='label-icon'>
									<Spinner size='sm' />
								</i>
							) : (
								<i className='ri-save-3-line label-icon'></i>
							)}
							{isEdit ? 'Editar' : 'Crear'} Campo
						</button>
					</div>
				</div>
			</Form>
		</>
	);
};

export default FieldForm;
